import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { scheduleThirdPartyScripts } from "@/utils/loadThirdPartyScripts";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById("root");

// Production builds include crawler-readable HTML inside #root. React still owns
// the interactive experience, so remove that static fallback before mounting.
// Non-JavaScript clients retain the prerendered article in the original HTML.
if (rootElement?.hasAttribute("data-prerendered")) {
  rootElement.replaceChildren();
  rootElement.removeAttribute("data-prerendered");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

scheduleThirdPartyScripts();
